<div class="auth-fluid bg-cover bg-repeat-no">
    <div class="auth-fluid-form-box">
        <div class="align-items-center d-flex h-100">
            <div class="card-body">
                <div class="auth-brand text-center text-lg-left">
                    <a href="index.html" class="logo-dark">
                        <span><img src="assets/images/logo-AA.png" alt="" height="24"></span>
                    </a>
                </div>
                <div class="m-auto">
                    <h4 class="text-dark-50 mt-4 font-weight-bold">Reset Password</h4>
                    <p class="text-muted mb-4">
                        Enter your email address and we'll email you instructions to reset your password.
                        Please keep in mind that a password reset affects all accounts associated with this email.
                    </p>
                </div>
                <form class="form-group mb-0 " [formGroup]="resetPassForm" (ngSubmit)="resetPassword()">
                    <div class="form-group">
                        <label for="email" class="form-label">Email Address</label>
                        <input class="form-control mb-2" type="email" id="email" autocomplete="off" formControlName="email" placeholder="Enter email" (change)="message = null" />
                        @if (email.invalid && email.dirty) {
                            <span class="text-danger text-left">Email Address Invalid</span>
                        }
                    </div>
                    <p class="text-primary text-center">{{message}}</p>
                    <button [disabled]="loading" class="btn btn-primary btn-block" type="submit">
                        @if (loading) {
                            <img src="../../../assets/images/loading.svg" alt="" height="20">
                        }
                        Reset Password
                    </button>
                    <p class="mt-2 text-center">
                        Back to
                        <button [routerLink]="['/login']" class="ml-0 border-0 bg-transparent text-primary"><b>Sign In</b></button>
                    </p>
                </form>
            </div> <!-- end .card-body -->
        </div> <!-- end .align-items-center.d-flex.h-100-->
    </div>
    <div class="auth-fluid-right text-center">
        <div class="auth-user-testimonial">
            <h1 class="mb-3">Welcome </h1>
            <p class="lead ">Build Your Dealership On A Solid Foundation with RockIT DMS.</p>
            <footer class="footer-alt p-1 d-flex align-items-end justify-content-between">
                <p class="text-muted mb-0">2020 Rock IT DMS</p>
                <div class="d-flex">
                    <p class="text-muted mx-2 mb-0">Privacy </p>
                    <p class="text-muted mx-2 mb-0">Legal</p>
                    <p class="text-muted mx-2 mb-0">Contact</p>
                </div>
            </footer>
        </div> <!-- end auth-user-testimonial-->
    </div>
</div>